import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';
import { Copyright } from './components/Copyright/Copyright';
import { Home } from './pages/Home/Home';
import { About } from './pages/About/About';
import { Gallery } from './pages/Gallery/Gallery';
import { Pricing } from './pages/Pricing/Pricing';
import { Contact } from './pages/Contact/Contact';
import { NotFound } from './pages/NotFound/NotFound';
import AnalyticsTracker from './components/AnalyticsTracker';
import { initGA } from './utils/googleAnalytics/google-analytics';
import tracker from './utils/openReplay';

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      tracker.start();
      initGA();
    }
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <AnalyticsTracker />
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <Copyright />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
